import type WaDialog from '@awesome.me/webawesome/dist/components/dialog/dialog.js'
import type { Component } from 'solid-js'
import { Logger } from 'besonders-logger'
import { Iconify } from '../mini-components'

const { WARN, LOG, DEBUG, VERBOSE, ERROR } = Logger.setup(Logger.INFO) // eslint-disable-line unused-imports/no-unused-vars

const inputStyle = {
	'--wa-input-font-size-small': '11px',
}
export const DeviceDialog: Component<{

}> = function deviceDialog() {
	// const [storeddeviceonic, setStoreddeviceonic] = createSignal()

	// const onInput = (evt: InputEvent) => {
	// 	setdevice((evt.target as HTMLInputElement).value)
	// }

	const afterhide = async (hideargs) => {
		DEBUG({ hideargs })
	}

	let deviceDialogRef: WaDialog
	return (
		<>
			<wa-button
				max-w-fit
				variant='brand'
				onClick={() => (deviceDialogRef as any)?.show()}
				size='s'
			>
				<div flex='~ items-center' gap-1>
					<Iconify slot='start' name='gear' size={4} />
					Device onboarding
				</div>
			</wa-button>
			<wa-dialog
				ref={deviceDialogRef}
				onwa-after-hide={afterhide}
				class='deviceDialog'
				w='90%'
			>
				<style>
					{`
					.deviceDialog::part(title) {
						padding: 0px;
					}
					.deviceDialog::part(panel) {
						width: 80%;
					}
					.deviceDialog::part(header) {
						padding: 1em 1em 0.5em 1em ;
					}
					.deviceDialog::part(body) {
						padding:  0.5em 1em 1em 1em;
					}
				`}
				</style>
				<h4 slot='label' py-1 px-2 m-0>
					Enter a name for the new device:
				</h4>
				<wa-input
					placeholder='phoneXYZ'
					// value={deviceToTest()}
					// onInput={onInput}
					filled
					font-mono
					size='s'
					max-w-full
					min-w-fit
					mb-4
					spellcheck={false}
					style={inputStyle}
				/>

				{/* <div>
					<wa-button
						max-w-fit
						variant={isKeyMatching() ? 'success' : 'default'}
						onClick={compareDerivedKeys}
						size='s'
					>
						<div flex='~ items-center' gap-1>
							<Iconify size={4} slot='start' name={isKeyMatching() ? 'check-circle' : 'question'} />
							Check
						</div>
					</wa-button>
					<wa-button
						max-w-fit
						ml-4
						variant='brand'
						onClick={async () => {
							setdevice(createdeviceonic(24).join(',')) // in Memory signal only
							testStats(256, 10)
						}}
						size='s'
					>
						<div flex='~ items-center' gap-1>
							<Iconify size={4} slot='start' name='plus-circle' />
							New
						</div>
					</wa-button>
					<wa-button
						max-w-fit
						ml-4
						variant='brand'
						onClick={async () => {
							importDerivationKey(deviceArray())
							testStats(256, 10)
						}}
						size='s'
					>
						<div flex='~ items-center' gap-1>
							<Iconify slot='start' size='4' name='shield-plus' />
							Import
						</div>
					</wa-button>
					<wa-button
						max-w-fit
						ml-4
						variant='danger'
						onClick={dealWithStoreddevice}
						size='s'
					>
						<div flex='~ items-center' gap-1>
							<Iconify slot='start' size='4' name='shield-warning' />
							Export
						</div>
					</wa-button>
				</div> */}
			</wa-dialog>
		</>
	)
}
